export const sources = {
  DUMB_SUBSCRIPTION: 'dumb_subscription',
  USER: 'user',
  ONBOARDING: 'onboarding',
  USER_ONE_OFF: 'user_one_off',
};
